import React, { FC } from 'react'
import { ConsentCheckbox } from './ConsentPage.styles'

interface CheckboxProps {
  checked: boolean
  setChecked: (checked: boolean) => void
}

export const Checkbox: FC<CheckboxProps> = ({ checked, setChecked }) => (
  <ConsentCheckbox checked={checked} onClick={() => setChecked(!checked)}>
    {checked ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M2 6C2 3.79086 3.79086 2 6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6Z"
          fill="#5E3CB4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.3692 8.46673C17.6638 8.781 17.6479 9.27461 17.3337 9.56925L10.9339 15.5692C10.6339 15.8505 10.167 15.8505 9.86694 15.5693L6.66671 12.5693C6.35243 12.2747 6.33649 11.781 6.63111 11.4668C6.92573 11.1525 7.41934 11.1365 7.73362 11.4312L10.4004 13.9311L16.2667 8.43119C16.581 8.13655 17.0746 8.15247 17.3692 8.46673Z"
          fill="white"
        />
      </svg>
    ) : (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H16C17.933 0.5 19.5 2.067 19.5 4V16C19.5 17.933 17.933 19.5 16 19.5H4C2.067 19.5 0.5 17.933 0.5 16V4Z"
          stroke="#4F555F"
        />
      </svg>
    )}
  </ConsentCheckbox>
)
